import d from "../../components/account/share/ScreenLogger.js";
import { MAX_SCREEN_LOGS as x } from "../../constants/screenLog.js";
import { createStrictContext as y } from "../../util/context/createStrictContext.js";
import * as r from "ramda";
import { useRef as C, useState as i, useCallback as p } from "react";
import { jsxs as L, jsx as b } from "react/jsx-runtime";
let s = 1;
const [h, E] = y("ScreenLog"), J = (u) => {
  const {
    enabled: c = !1,
    children: l
  } = u, e = C([]), [f, a] = i(!1), [g, m] = i([]), n = p((t) => {
    try {
      return JSON.stringify(t, null, 2);
    } catch {
      return "JSON stringify error";
    }
  }, []), S = p((t) => {
    const o = {
      index: s,
      input: n(t.input),
      operation: t.operation,
      output: n(t.output),
      type: t.type
    };
    r.length(e.current) < x ? (e.current = r.prepend(o, e.current), s++) : (e.current = r.prepend(o, r.dropLast(1, e.current)), s++), m(e.current);
  }, [n]);
  return /* @__PURE__ */ L(h, {
    value: {
      enabled: c,
      logs: g,
      open: f,
      insert: S,
      setOpen: a
    },
    children: [l, c && /* @__PURE__ */ b(d, {})]
  });
};
export {
  J as ScreenLogProvider,
  E as useScreenLogContext
};
//# sourceMappingURL=ScreenLogContext.js.map
